import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _styled from "@emotion/styled-base";
import _get from "lodash/fp/get";
var _excluded = ["item"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import { useConfig, useCurrentDoc, useDocs } from 'docz';
import { Link } from 'gatsby';
import * as styles from 'gatsby-theme-docz/src/components/NavLink/styles';
import React from 'react';
import { jsx } from 'theme-ui';
import { jsx as ___EmotionJSX } from "@emotion/core";

var Container = _styled("div", {
  target: "e1lwqfwh0"
})(process.env.NODE_ENV === "production" ? {
  name: "eg4h5",
  styles: "a{transition:opacity 0.2s ease;&:hover{opacity:0.75;}}"
} : {
  name: "eg4h5",
  styles: "a{transition:opacity 0.2s ease;&:hover{opacity:0.75;}}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var getHeadings = function getHeadings(route, docs) {
  var doc = docs.find(function (item) {
    return item.route === route;
  });

  var headings = _get('headings', doc);

  return headings ? headings.filter(function (heading) {
    return heading.depth === 2;
  }) : [];
};

var getCurrentHash = function getCurrentHash() {
  if (typeof window === 'undefined') {
    return '';
  }

  return window.location ? decodeURI(window.location.hash) : '';
};

export var NavLink = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var item = _ref.item,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useConfig = useConfig(),
      themeConfig = _useConfig.themeConfig;

  var docs = useDocs();
  var current = useCurrentDoc();

  if (item.hidden) {
    return null;
  }

  var to = item.route;
  var headings = docs && getHeadings(to, docs);
  var isCurrent = item.route === current.route;
  var showHeadings = !_get('menu.headings.rightSide', themeConfig, false) && isCurrent && headings && headings.length > 0;
  var currentHash = getCurrentHash();
  return jsx(Container, null, jsx(Link, _extends({}, props, {
    to: to,
    sx: _objectSpread(_objectSpread({}, styles.link), {}, {
      my: 0,
      padding: '.4rem 1.5rem'
    }),
    activeClassName: "active",
    ref: ref
  })), showHeadings && headings.map(function (heading) {
    return jsx(Link, {
      key: heading.slug,
      to: to + "#" + heading.slug,
      sx: _objectSpread(_objectSpread({}, styles.smallLink), {}, {
        my: 0,
        padding: '.4rem 1.5rem'
      }),
      className: currentHash === "#" + heading.slug ? 'active' : ''
    }, heading.value);
  }));
});

if (typeof NavLink !== 'undefined' && NavLink && NavLink === Object(NavLink) && Object.isExtensible(NavLink) && !Object.prototype.hasOwnProperty.call(NavLink, '__filemeta')) {
  Object.defineProperty(NavLink, '__filemeta', {
    configurable: true,
    value: {
      name: "NavLink",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/components/NavLink/index.js"
    }
  });
}